import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _styled from "@emotion/styled-base";
import _get from "lodash/fp/get";
var _excluded = ["item"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import { useConfig, useCurrentDoc, useDocs } from 'docz';
import { Link } from 'gatsby';
import * as styles from 'gatsby-theme-docz/src/components/NavLink/styles';
import React from 'react';
import { jsx } from 'theme-ui';
import { jsx as ___EmotionJSX } from "@emotion/core";

var Container = _styled("div", {
  target: "e1lwqfwh0"
})(process.env.NODE_ENV === "production" ? {
  name: "eg4h5",
  styles: "a{transition:opacity 0.2s ease;&:hover{opacity:0.75;}}"
} : {
  name: "eg4h5",
  styles: "a{transition:opacity 0.2s ease;&:hover{opacity:0.75;}}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var getHeadings = function getHeadings(route, docs) {
  var doc = docs.find(function (item) {
    return item.route === route;
  });

  var headings = _get('headings', doc);

  return headings ? headings.filter(function (heading) {
    return heading.depth === 2;
  }) : [];
};

var getCurrentHash = function getCurrentHash() {
  if (typeof window === 'undefined') {
    return '';
  }

  return window.location ? decodeURI(window.location.hash) : '';
};

export var NavLink = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var item = _ref.item,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useConfig = useConfig(),
      themeConfig = _useConfig.themeConfig;

  var docs = useDocs();
  var current = useCurrentDoc();

  if (item.hidden) {
    return null;
  }

  var to = item.route;
  var headings = docs && getHeadings(to, docs);
  var isCurrent = item.route === current.route;
  var showHeadings = !_get('menu.headings.rightSide', themeConfig, false) && isCurrent && headings && headings.length > 0;
  var currentHash = getCurrentHash();
  return jsx(Container, null, jsx(Link, _extends({}, props, {
    to: to,
    sx: _objectSpread(_objectSpread({}, styles.link), {}, {
      my: 0,
      padding: '.4rem 1.5rem'
    }),
    activeClassName: "active",
    ref: ref
  })), showHeadings && headings.map(function (heading) {
    return jsx(Link, {
      key: heading.slug,
      to: to + "#" + heading.slug,
      sx: _objectSpread(_objectSpread({}, styles.smallLink), {}, {
        my: 0,
        padding: '.4rem 1.5rem'
      }),
      className: currentHash === "#" + heading.slug ? 'active' : ''
    }, heading.value);
  }));
});

if (typeof NavLink !== 'undefined' && NavLink && NavLink === Object(NavLink) && Object.isExtensible(NavLink) && !Object.prototype.hasOwnProperty.call(NavLink, '__filemeta')) {
  Object.defineProperty(NavLink, '__filemeta', {
    configurable: true,
    value: {
      name: "NavLink",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/components/NavLink/index.js"
    }
  });
}